import { Assignment, HighlightOff } from '@mui/icons-material';
import {
  Paper,
  Typography,
  FormControl,
  CardContent,
  Button,
  Container,
  Grid,
  TextField,
  useMediaQuery,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { QrReader } from 'react-qr-reader';
import LoadingButton from '../../@iosper/components/LoadingButton';
import { useForm } from 'react-hook-form';
import { validarTokenValidadOrdenImpresa, saveValidarOrdenImpresa } from '../../services/Seo/Orden';
import CustomizedSnackbars from '../Notifications/SnackBar';
import { Redirect, useLocation } from 'react-router-dom';
import { Box } from '@mui/system';
import ReplayIcon from '@mui/icons-material/Replay';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ReactComponent as WarningImg } from '../../assets/images/svg/mobile-warning.svg';
import { sendMessageOrdenCancelada } from '../../services/WebSocket/WebSocket';
import OrdenValidadaModal from './OrdenValidadaModal';
import { LectorQRGenerarOrdenDigitalMobile } from './components/LectorQRGenerarOrdenDigitalMobile';
import { useTheme } from '@emotion/react';

const ValidarOrdenImpresa = (props) => {
  const theme = useTheme();
  const location = useLocation();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [success, setSuccess] = useState('');
  // Dialog Orden
  const [loadingOrden, setLoadingOrden] = useState(false);
  const [showOrdenValidar, setShowOrdenValidar] = useState(false);
  const [showScanner, setShowScanner] = useState(!location?.state?.qrToken);
  const [showOrdenValidadaModal, setShowOrdenValidadaModal] = useState(false);
  const [onCancelar, setOnCancelar] = useState(false);
  const [qrNoValido, setQrNoValido] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showBtnHelp, setShowBtnHelp] = useState(false);
  const [dataToken, setDataToken] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setShowBtnHelp(true);
    }, 180000); //180000 milisegundos son 3 munitos
  }, [showBtnHelp]);

  useEffect(() => {
    if (location?.state?.tokenData) {
      // Datos ya validados por SmartQrReader — no repetir llamada API
      setDataToken(location.state.tokenData);
      setShowScanner(false);
      setShowOrdenValidar(true);
    } else if (location?.state?.qrToken) {
      validarToken(location.state.qrToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnQRResult = (result, e) => {
    try {
      if (result) {
        setShowScanner(false);
        const res = result?.text;
        JSON.parse(res);
        validarToken(res);
      }
    } catch (e) {
      setQrNoValido(true);
    }
  };

  const validarToken = async (token) => {
    try {
      const data = await validarTokenValidadOrdenImpresa(token);
      setDataToken(data);
      setShowScanner(false);
      setShowOrdenValidar(true);
    } catch (e) {
      setShowScanner(true);
    }
  };

  const validarOrdenImpresa = async (data) => {
    try {
      await saveValidarOrdenImpresa(data);
      setLoadingOrden(false);
      setShowScanner(false);
      setShowOrdenValidar(false);
      setShowOrdenValidadaModal(true);
    } catch (e) {
      setLoadingOrden(false);
      setShowScanner(true);
      setShowOrdenValidar(false);
    }
  };

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });

  const onSubmit = (data, event) => {
    setLoadingOrden(true);
    event.preventDefault();
    validarOrdenImpresa(dataToken);
  };

  const handleClose = () => {
    setOnCancelar(true);
  };

  const handleReplyFromQrNoValido = () => {
    setQrNoValido(false);
  };

  const handleHelp = () => {
    setShowHelp(true);
  };

  const handleReplyFromHelp = () => {
    setShowHelp(false);
    setShowBtnHelp(false);
  };

  const enviarMensajeCancelada = async () => {
    try {
      await sendMessageOrdenCancelada(dataToken.token);
    } catch (e) {
      console.log(e);
    }
  };

  const handleBorrarMensaje = () => {
    setSuccess('');
  };

  const contentHelp = (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={3} justifyContent='center' alignItems='center'>
        <Grid item>
          <Grid container direction='row' spacing={1}>
            <Grid item>
              <HelpOutlineIcon color='primary' />
            </Grid>
            <Grid item>
              <Typography variant='subtitle2'>¿Querés validar una Orden Impresa?</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant='body2'>
            Apuntá la cámara hacia el código QR que generó el prestador.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant='body2'>
            Una vez leído correctamente el código, seguí las intrucciones en pantalla para completar
            el proceso.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            size='small'
            startIcon={<ReplayIcon />}
            variant='contained'
            color='primary'
            fullWidth={true}
            onClick={(e) => handleReplyFromHelp(e)}
          >
            Reintentar
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );

  const contentQrNoValido = (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={3}>
        <Grid item>
          <Grid container direction='row' justifyContent='center' alignItems='center'>
            <Grid xs={2} item>
              <WarningImg />
            </Grid>
            <Grid xs={10} item>
              <Typography align='center' variant='body2' color='secondary'>
                Oops! No pudimos escanear correctamente el código QR
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant='body2'>Verificá que tu cámara esté alineada.</Typography>
        </Grid>
        <Grid item>
          <Typography variant='body2'>
            Verificá que la cámara de tu dispositivo esté limpia.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant='body2'>
            Verificá que el reflejo de las luces no genere ruidos en la foto.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            size='small'
            startIcon={<ReplayIcon />}
            variant='contained'
            color='primary'
            fullWidth={true}
            onClick={(e) => handleReplyFromQrNoValido(e)}
          >
            Reintentar
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );

  const contentSeleccionarAfiliado = (
    <Paper sx={{ p: 2 }}>
      <Typography gutterBottom variant='h5' component='h2'>
        Validar Orden Afiliado
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CardContent>
          <FormControl fullWidth={true} variant='outlined' margin='normal'>
            <TextField
              id='afiliado'
              variant='standard'
              label='N° Orden'
              defaultValue={`${dataToken?.numeroOrden}`}
              size='small'
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
          </FormControl>
          <FormControl fullWidth={true} variant='outlined' margin='normal'>
            <TextField
              id='afiliado'
              variant='standard'
              label='Afiliado'
              defaultValue={`${dataToken?.nyaAfiliado}`}
              size='small'
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
          </FormControl>
          <FormControl fullWidth={true} variant='outlined' margin='normal'>
            <TextField
              id='afiliado'
              variant='standard'
              label='N° Documento'
              defaultValue={`${dataToken?.numeroDocumento}`}
              size='small'
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
          </FormControl>
          <FormControl fullWidth={true} variant='outlined' margin='normal'>
            <TextField
              id='afiliado'
              variant='standard'
              label='Fecha Emision'
              defaultValue={`${dataToken?.fecha}`}
              size='small'
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
          </FormControl>
          <LoadingButton
            fullWidth={true}
            variant='contained'
            size='medium'
            color='primary'
            startIcon={<Assignment />}
            type='submit'
            loading={loadingOrden ? 'show' : 'hide'}
            content={'Validar'}
          />
        </CardContent>
      </form>
    </Paper>
  );

  const contentScaner = () => {
    if (isMobileScreen) {
      return (
        <LectorQRGenerarOrdenDigitalMobile
          onResult={handleOnQRResult}
          title='Validar Orden'
          description='Escaneá el código QR generado por el prestador desde <b>Mi Consultorio</b>. Esto confirma tu identidad y que usaste la prestación.'
        />
      );
    }

    return (
      <Paper sx={{ p: 2 }}>
        <Typography gutterBottom variant='h5' component='h2'>
          Validar Orden
        </Typography>
        <Typography variant='string' component={'div'} align='center' sx={{ pb: 3 }}>
          Escaneá el código QR generado por el prestador desde Mi Consultorio en Mi OSER. Esto confirma tu identidad y que usaste la prestación.
        </Typography>
        <QrReader
          constraints={{ facingMode: 'environment' }}
          onResult={handleOnQRResult}
          style={{ width: '100%' }}
        />
        <Box sx={{ p: 2 }}>
          <Button
            size='small'
            variant='text'
            color='primary'
            fullWidth={true}
            onClick={(e) => handleHelp(e)}
          >
            ¿Necesitás ayuda?
          </Button>
          <Button
            size='small'
            startIcon={<HighlightOff />}
            variant='contained'
            color='neutral'
            fullWidth={true}
            onClick={(e) => handleClose(e)}
          >
            Cancelar
          </Button>
        </Box>
        <CustomizedSnackbars
          open={success}
          autoHideDuration={10000}
          onDeleteMessage={handleBorrarMensaje}
          severity='success'
          message={success}
        />
      </Paper>
    )
  };

  return onCancelar ? (
    <Redirect
      to={{
        pathname: '/',
        state: { from: '/read-orden' },
      }}
    />
  ) : qrNoValido ? (
    contentQrNoValido
  ) : showHelp ? (
    contentHelp
  ) : (
    <Container component='main' maxWidth='sm'>
      {showScanner ? contentScaner() : null}
      {showOrdenValidar ? contentSeleccionarAfiliado : null}
      <OrdenValidadaModal
        open={showOrdenValidadaModal}
        onClose={() => setShowOrdenValidadaModal(false)}
        dataOrden={dataToken}
      />
    </Container>
  );
};

export default ValidarOrdenImpresa;
